import React from 'react'
import Expander from '../Expander'
import Text from '../Text'
import ActionButton from '../ActionButton'

export default function(notification, size = 1) {
  //const redirect = useRedirect()
  function action() {
    if ('routerHistory' in window) {
      ;(window as any).routerHistory.push('/integration/booking', {})
    }
  }

  return (
    <Expander size={size} id={notification.id} label={notification.subtitle}>
      <Text size={size}>
        <span dangerouslySetInnerHTML={{ __html: notification.message }} />
        <ActionButton
          size={size}
          action={action}
          label={notification.actionLabel}
        />
      </Text>
    </Expander>
  )
}
